import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useCustomToast } from '../../components';
import {
  PetitionsFilter,
  PetitionsResponse,
} from '../../modules/Petitions/types';
import { PetitionsReqAPI } from '../../modules/Petitions/api';
import { approveRequestsReqAPI } from '../../modules/ApproveRequests/api/approveRequestsAPI';

// Query key for caching
const keyQuery = ['petitions'] as const;

export const usePetitions = (filters?: Partial<PetitionsFilter>) => {
  return useQuery<PetitionsResponse, Error>({
    queryKey: [keyQuery, filters || {}],
    queryFn: ({ queryKey }) => PetitionsReqAPI.gets({ queryKey }),
    enabled: true,
    staleTime: 0,
  });
};

export const usePetitionsById = (id?: string) => {
  return useQuery({
    queryKey: [...keyQuery, id],
    queryFn: () => (id ? PetitionsReqAPI.get(id) : Promise.resolve(undefined)),
    enabled: !!id,
  });
};

export const useCreatePetitions = () => {
  const { showToast } = useCustomToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: PetitionsReqAPI.post,
    onSuccess: () => {
      showToast('success', 'Petición creada');
      queryClient.invalidateQueries({ queryKey: [keyQuery, {}] });
    },
  });
};

// Delete a goods request
export const useDeletePetitios = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => PetitionsReqAPI.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keyQuery });
    },
  });
};

//Export excel

export const useExportPetitions = () => {
  const { showToast } = useCustomToast();
  return useMutation({
    mutationFn: (ids: string[]) => PetitionsReqAPI.export(ids),
    onSuccess: () => {
      showToast('success', 'Exportación exitosa');
    },
    onError: () => {
      showToast('error', 'Error al exportar');
    },
  });
};

// Cancel a request
export const useCancelRequest = () => {
  return useMutation<void, Error, { id: string; data: any }>({
      mutationFn: async ({ id, data }) => approveRequestsReqAPI.cancel(id, data),
  });
};
